





























import Vue from 'vue'
import mediaMixin from '@/mixins/media-mixin'
import User from '@/types/User.interface'
export default Vue.extend({
    mixins: [mediaMixin],
    props: {
        borderless: {
            type: Boolean,
            default: false
        },
        save: {
            type: Boolean,
            default: false
        },
        selectedUser: {
            type: Object,
            required: true
        },
        size: {
            type: Number,
            default: 100
        },
        upload: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uploading: false
        }
    },
    computed: {
        loading(): boolean {
            return this.$store.getters.loading
        },
        style(): string {
            //  If borderless, return empty
            if (this.borderless) return ''

            //  else, return border style
            return `border:2px solid ${this.$colors.mdPurple70}`
        },
        textSize(): string {
            //  If size is over 50, use display-1, else blank
            if (this.size >= 50) return 'display-1'
            else return ''
        },
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        filesChange(event: Event): void {
            //  Cast the target to an HTMLInputElement
            const target = event.target as HTMLInputElement

            let files = Array.from(target.files)

            let filtered = this.validateFiles(files)

            if (filtered.invalidFiles.length > 0) {
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Invalid Files',
                    icon: 'mdi-alert-circle',
                    text: this.getInvalidMessage(filtered.invalidFiles)
                })
            }

            let formData = new FormData()
            formData.append('logo', filtered.validFiles[0])

            //  Instantiate a filereader
            const reader = new FileReader()

            //  Set this reader to replace src onload
            reader.onload = function () {
                const mock = document.getElementById('mockLogo') as HTMLImageElement
                if (mock) mock.src = reader.result as string
            }

            //  Set uploading to true
            this.uploading = true

            //  Read our file
            reader.readAsDataURL(filtered.validFiles[0])

            //  If we have the save prop set, emit our formdata and return
            if (this.save) return this.$emit('uploaded', formData)

            //  Else, continue to upload
            formData.append('id', this.selectedUser.id)
            this.uploadLogo(formData)
        },
        openUpload(): void {
            this.$refs.logoUpload.click()
        },
        async uploadLogo(formData: FormData): Promise<User> {
            //  Upload our image
            const user = await this.$store.dispatch('usersLogoUpload', formData)

            //  Regardless of if it fails or not, stop uploading
            this.uploading = false

            //  If fails, do nothing
            if (!user) return

            //  Set our logo route
            this.selectedUser.logo_route = user.logo_route

            //  If this is our admin user, replace their logo too
            if (this.selectedUser.id === this.user.id)
                this.user.logo_route = user.logo_route

            //  Return our user
            return user
        }
    }
})
